import React from "react";
// #region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CurrencyEnums } from "models/enums";
import { SummaryTotalFormatterProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region component
import { Grid } from "@mui/material";
import CurrencyValueFormatter from "./currencyValueFormatter";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const SummaryTotalFormatter: React.FC<SummaryTotalFormatterProps> = (props) => {
  const { total, subTotals } = props;

  const getAmounts = (cellValue: WintSuperkollAPIModel.CurrencyValue[] | undefined) => {
    const listAmount: any[] = [];
    const sek = cellValue?.find((c) => c.type === CurrencyEnums.CurrencyCode.SEK)?.value;
    listAmount.push(LocalizationHelperInstance.getFormattedCurrency(sek ?? 0, CurrencyEnums.CurrencyCode.SEK, 2, 2));

    cellValue?.forEach((element) => {
      if (element.type !== CurrencyEnums.CurrencyCode.SEK) {
        listAmount.push(LocalizationHelperInstance.getFormattedCurrency(element.value, element.type, 2, 2));
      }
    });
    return listAmount.join(", ");
  };

  return (
    <Grid container>
      <CurrencyValueFormatter cellValue={total?.cellValue ?? []}></CurrencyValueFormatter>
      {subTotals?.map((item, index) => {
        return (
          <Grid key={index} container justifyContent={"flex-end"} className={cssExports.tableSummaryOther}>
            {item.title ? `${item.title}: ` : ""}
            {getAmounts(item.cellValue)}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SummaryTotalFormatter;
